module.exports = __webpack_public_path__ + "public/img/arrow-lt.f7e0b075.svg";